import VideoTimeLine from './VideoTimeLine';
import Video2 from './Video2';

import './video.scss';

export {
  VideoTimeLine
};

export default Video2;